export default "__VITE_ASSET__hiZBMqr___"